import { render, staticRenderFns } from "./GroupConversationParticipants.vue?vue&type=template&id=09803919"
import script from "./GroupConversationParticipants.vue?vue&type=script&lang=ts"
export * from "./GroupConversationParticipants.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09803919')) {
      api.createRecord('09803919', component.options)
    } else {
      api.reload('09803919', component.options)
    }
    module.hot.accept("./GroupConversationParticipants.vue?vue&type=template&id=09803919", function () {
      api.rerender('09803919', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inbox/GroupConversationParticipants.vue"
export default component.exports